import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Label, Image, Rail } from 'semantic-ui-react'
import {isMobile} from '../utils';

class FrontPage extends Component {
    render() {
        const fontSize = isMobile() ? '1.4rem' : '3.7rem';
        const fontFamily = "Verdana, Geneva, sans-serif";

        return (
            <div>
                <Image style={Style.image} src={this.props.image} />
                <Rail style={Style.rail} internal position='right'>
                    <Label style={{...Style.label, fontSize, fontFamily}}>{this.props.subtitle}</Label>
                </Rail>
            </div>
        );
    }
}
FrontPage.PropTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    imagePath: PropTypes.string,
};

const mobile = isMobile();
const Style = {
    image: {
      width: '100%',
      marginTop: mobile ? '-35px':'75px',
    },
    titleBack: {
        height: '100px',
        width: '100%',
        margin: '30% 0',
        position: 'absolute',
        top: '10px',
        background: 'lightgray',
        opacity: '0.6',
    },
    rail: {
        width: '110%',
        margin: '15% 50%',
        position: 'absolute',
        opacity:'0.6',
    },
    label: {
      height: mobile ?'4rem':'7rem',
      width: '100%',
      color: '#0033cc',
      margin: '26% 20% 0 0',
      position: 'absolute',
      background: '#996633',

    },
    title: {
        height: 'auto',
        width: 'auto',
        color: '#ffffff',
        fontFamily: "Futura",//"'Palatino Linotype', 'Book Antiqua', Palatino, serif",
        fontSize: '72px',
        //fontWeight: '200',
        margin: '30% 7%',
        position: 'absolute',
        top: '10px',
        textAlign: 'center',
        lineHeight: 'normal',
    },
    text: {
        height:'auto',
        width: 'auto',
        color: '#996633',// '#f0ec0e',
        // textShadow: '3px 0 green, 0 3px green, 3px 0 green, 0 3px green',
        fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif", 
        fontSize: '30px',
        fontWeight: '400',
        margin: '1% 10%',
        padding: '2%',
        position: 'absolute',
        top: '60%',
        textAlign: 'left',
        background: 'lightgray',
        lineHeight: 'normal',
        opacity:'0.8',
      }
  }
export default FrontPage


// WEBPACK FOOTER //
// ./src/components/FrontPage.js